import React from "react"
import CloseIcon from "../../assets/icons/close.svg"

const Modal = ({ showModal, hide, member }) => {

    if (!showModal) {
        return null;
    }

    return (
        <div className="overlay" onClick={hide}>
            <section id="modal" className="modal">
                <a className="close-btn" onClick={hide}><img alt="" src={CloseIcon} alt=''/></a>
                {member.teamMember.alternatePhoto ? (
                    <div className="image-wrapper">
                        <img alt={member.teamMember.alternatePhoto?.altText}
                          src={member.teamMember.alternatePhoto?.sourceUrl}/>
                    </div>
                ) : (
                    <div className="image-wrapper">
                        <img alt={member.featuredImage.node?.altText}
                          src={member.featuredImage.node?.sourceUrl}/>
                    </div>
                )}
                <div className="content-wrapper">
                    {member.title && (
                        <h3 className="name">{member.title}</h3>
                    )}
                    {member.teamMember.jobTitle && (
                        <h5 className="title">{member.teamMember.jobTitle}</h5>
                    )}
                    {member.teamMember.bio && (
                        <div className="bio" dangerouslySetInnerHTML={{ __html: member.teamMember.bio }}></div>
                    )}
                </div>
            </section>
        </div>
    )
}

export default Modal;